import styled, { keyframes } from "styled-components";

// The three jumping dots of an in-progress state, exactly as the AI chat's
// "Generating..." indicator draws them: 6px dots, 4px apart, jumping 8px
// in turn. They paint in currentColor, so the surrounding text color sets
// theirs. The wrapper is a plain inline-flex so the dots keep their own
// size wherever the row puts them.

const jump = keyframes`
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-8px); }
`;

const Dot = styled.span<{ $delay: string }>`
  display: inline-block;
  margin-right: 4px;
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: currentColor;
  animation: ${jump} 0.6s infinite ease-in-out;
  animation-delay: ${({ $delay }) => $delay};
`;

const Dots = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export function JumpingDots({ className }: { className?: string }) {
  return (
    <Dots className={className} aria-hidden>
      <Dot $delay="0s" />
      <Dot $delay="0.2s" />
      <Dot $delay="0.4s" />
    </Dots>
  );
}
